function formatPeriod(period) {
  return period.substring(0, 4) + "/" + period.substring(5);
}

export { formatPeriod };
